export function setState(state, [field, value]) {
  state[field] = value;
}

export function setQuotePDFHref(state, href) {
  state.quotePDFHref = href;
}

export function setApprovals(state, approvals) {
  state.approvals = approvals;
}

export function setApproval(state, approval) {
  state.approval = approval;
}

export function snapshotApproval(state) {
  state.approvalSnapshot = { ...state.approval };
}

export function setHrApprovalsStatus(state, status) {
  state.hrApprovalsStatus = status;
}

export function setHrApprovalsType(state, type) {
  state.hrApprovalsType = type;
}

export function setHrApprovalDenyOpen(state, value) {
  state.hrApprovalDenyOpen = value;
}

export function setHrApplicationApproval(state, application) {
  state.application = application;
}
